import(/* webpackMode: "eager" */ "/Users/martina/Desktop/Project/template-0213/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SentryProvider"] */ "/Users/martina/Desktop/Project/template-0213/components/sentry-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/Users/martina/Desktop/Project/template-0213/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/Users/martina/Desktop/Project/template-0213/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/Users/martina/Desktop/Project/template-0213/components/ui/tooltip.tsx");
